module.exports = __webpack_public_path__ + "img/path_log.f48771ce.png";